export default "__VITE_ASSET__BvcuoS49__"